import { updateArPhoto, deleteArPhoto } from '../../services/apiClient.js';
import { photoDownloadName } from '../../utils/photoArchive.js';
import { applyAtPrefix } from '../../utils/stringUtils.js';

// Liste propre au dashboard (photos masquées comprises) : l'état partagé
// get/setArPhotos sert à la carte et ne doit contenir que les visibles.
export function createArPhotoDashboardFeature({ fetchArPhotos }) {
  let rows = [];
  const photoList    = document.getElementById('photoList');
  const photoEmpty   = document.getElementById('photoEmpty');
  const photoCardTpl = document.getElementById('photoCardTpl');

  function createPhotoCard(photo) {
    const frag = photoCardTpl.content.cloneNode(true);
    const li   = frag.querySelector('.photo-card');

    const imageUrl = `/api/ar-photos/${photo.id}/image`;

    li.querySelector('.photo-thumb').src = imageUrl;
    // Original avec position et date inscrites dans l'EXIF (archivage).
    const dlLink = li.querySelector('.photo-download');
    dlLink.href  = imageUrl + '?download=1';
    dlLink.setAttribute('download', photoDownloadName({ type: 'ar', ...photo }));

    // Masquer : retirée du site (Escales, carte, Sillages), gardée en base et
    // sur S3 -- réversible, contrairement à la suppression.
    const btnHide = li.querySelector('.photo-hide');
    function showHidden() {
      li.classList.toggle('photo-card--hidden', photo.hidden);
      btnHide.textContent = photo.hidden ? 'Afficher' : 'Masquer';
      btnHide.title       = photo.hidden ? 'Remettre la photo sur le site' : 'Retirer la photo du site sans la supprimer';
    }
    showHidden();
    btnHide.addEventListener('click', async () => {
      const hidden = !photo.hidden;
      btnHide.disabled = true;
      try {
        const res = await updateArPhoto(photo.id, { hidden });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        photo.hidden = hidden;
        showHidden();
      } catch (err) {
        console.error('Erreur masquage photo:', err);
      } finally {
        btnHide.disabled = false;
      }
    });

    li.querySelector('.photo-date').textContent = new Date(photo.createdAt)
      .toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' });

    const pseudoEl      = li.querySelector('.dash-pseudo');
    const btnEditPseudo = li.querySelector('.dash-btn--edit-pseudo');

    function getArLabel() {
      return photo.pseudo || '—';
    }

    function showPseudoText() {
      pseudoEl.textContent = getArLabel();
      pseudoEl.hidden      = false;
      btnEditPseudo.hidden = false;
    }

    function showPseudoInput() {
      pseudoEl.hidden      = true;
      btnEditPseudo.hidden = true;
      const inp = document.createElement('input');
      inp.type           = 'text';
      inp.className      = 'dash-pseudo-input';
      inp.placeholder    = 'Pseudo Instagram (ou autre)';
      inp.autocapitalize = 'none';
      li.querySelector('.dash-pseudo-row').insertBefore(inp, pseudoEl);
      inp.addEventListener('input', () => applyAtPrefix(inp));

      let committed = false;
      function commit() {
        if (committed) return;
        committed    = true;
        const val    = inp.value.trim();
        inp.remove();
        photo.pseudo = val;
        showPseudoText();
        updateArPhoto(photo.id, { pseudo: val }).catch(err => console.error('Erreur pseudo:', err));
      }
      inp.addEventListener('blur', commit);
      inp.addEventListener('keydown', e => {
        if (e.key === 'Enter') { e.preventDefault(); inp.blur(); }
      });
      inp.focus();
    }

    showPseudoText();
    btnEditPseudo.addEventListener('click', () => {
      pseudoEl.hidden      = true;
      btnEditPseudo.hidden = true;
      showPseudoInput();
    });

    li.querySelector('.photo-delete').addEventListener('click', async () => {
      li.classList.add('dash-card--removing');
      li.addEventListener('animationend', async () => {
        try {
          await deleteArPhoto(photo.id);
          rows = rows.filter(p => p.id !== photo.id);
          li.remove();
          photoEmpty.hidden = rows.length > 0;
        } catch (err) {
          console.error('Erreur suppression photo:', err);
        }
      }, { once: true });
    });

    li.dataset.id = photo.id;
    return li;
  }

  async function load() {
    try {
      rows = await fetchArPhotos({ includeHidden: true });
      photoList.innerHTML   = '';
      photoEmpty.hidden     = rows.length > 0;
      for (const photo of rows) {
        photoList.appendChild(createPhotoCard(photo));
      }
    } catch (err) {
      console.error('Erreur chargement photos:', err);
    }
  }

  return { load };
}
